import React from "react";
import styles from "./user.module.scss";
import KoDP from "packages/dp";
import { KoText } from "packages/typography";

function Assignees(props) {
  const { size = 19, row, column } = props;

  let users = [];

  if (column?.key === "reporter") {
    if (row?.reporterDetails) {
      users = [row.reporterDetails];
    }
  }
  else if (column?.key === "leads") {
    users = row?.leadsProfile || [];
  }
  else {
    const singleUser = row?.assigneeDetails || row?.ownerProfile || row?.assigneeProfile || row?.reporterDetails || row?.ownerDetails || row?.createdByProfile || row?.createdByDetails;
    if (singleUser) {
      users = [singleUser];
    }
  }

  if (!users.length) return null;

  return (
    <div className={styles.membersWrapper}>
      {users.map((userObj, index) => {
        const firstLetter = userObj?.firstName
          ? userObj.firstName.charAt(0).toUpperCase()
          : "A";

        return (
          <div
            key={userObj?.userId || index}
            className={`profileChar ${styles.membersWrapper}`}
          >
            <div
              className={`${styles.circle} ${
                userObj?.firstName
                  ? userObj.firstName.charAt(0).toLowerCase()
                  : "a"
              }`}
            >
              {userObj?.logo ? (
                <KoDP
                  className={styles.btn}
                  shape="circle"
                  logo={userObj.logo}
                  width={size}
                  height={size}
                />
              ) : (
                <KoText
                  className={styles.letter}
                  text={firstLetter}
                />
              )}
            </div>
            <div className={styles.memberInfo}>
              <KoText
                text={`${userObj?.firstName || ""} ${userObj?.lastName || ""}`}
                className={styles.memberName}
              />

              
              {(userObj?.email || row?.email) && (
                <KoText
                  text={`${userObj?.email || row?.email}`}
                  className={styles.email}
                />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Assignees;
